import styles from '@/styles/goodsComponentWithDiscountNew.module.scss'
import { Rate, Button, message } from 'antd'
import Image from 'next/image'
import { getToken } from '@/utils/auth'
import { localStorageService } from "@/utils/storageService"
import { useState } from 'react'
import Link from 'next/link'
import MyTags from "@/components/MyTags"
import useCartActions from '@/utils/addTocartAction'
import No1 from '@/svgs/1.svg'
import No2 from '@/svgs/2.svg'
import No3 from '@/svgs/3.svg'
import No4 from '@/svgs/4.svg'
import No5 from '@/svgs/5.svg'

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const apiDomain = publicRuntimeConfig.apiDomain

interface GoodsDetail {
  productID: string;
  productName: string;
  url: string;
  imgUrl: string;
  promotion: {
    productID: number;
    promotionType: number;
    promotionPrice: number;
    normalPrice: number;
    endDate: string;
    status?: number;
    notified?: number;
    pointRate: string;
    promotionRate: number;
  };
  reviewCount?: number;
  price: number;
  normalPrice: number;
  tagTitle?: string;
  tagBgColor?: string;
  tagFontColor?: string;
  freeShipping: number;
  onSale: number;
  reduced: number;
  isNew: number;
  position?: number,
  location?: string;
  isEmailOnly: any,
  promotionTypeID: string | number;
  review: {
    avgRank: number;
    total: number;
  };
  hiddenTags?: boolean;
  hiddenReviews?: boolean;
  hiddenDiscount?: boolean;
  showLeval?: boolean;
  leval?: number;
  [key: string]: any;
}

export default function GoodsComponentWithDiscount(props: GoodsDetail) {
  const { addToCart } = useCartActions();
  const [showAdded, setShowAdded] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)

  const addToCartCallBack = (response:any) => {
    if (response != "error") {
      setShowAdded(true)
      setBtnLoading(false)
    } else {
      setBtnLoading(false)
    }
  }

  const preOrder = async (event: any) => {
    event.stopPropagation()
    setBtnLoading(true)
    const isLogin = getToken() == '1'
    const pid = props.productID
    if (!isLogin) {
      location.href = '/login?redirect=' + encodeURIComponent('/checkout?p=' + pid + '&t=' + 1);
      return false;
    }
    location.href = '/checkout?p=' + pid + '&t=1';
  }

  let price = `${Number(props.normalPrice).toFixed(2)}`.split('.')
  if (props.price && props.price != props.normalPrice) {
    price = `${Number(props.price).toFixed(2)}`.split('.')
  }

  return (
    <div className={`${styles["goods-box"]}`}>
      <div className={styles["imgthumb"]}>
        <Link href={props.url} legacyBehavior>
          <a className={styles["goodsLink"]} rel="noopener noreferrer">
            {props.showLeval && (
              <div className={styles["svg-box"]}>
                {props.leval == 1 && <No1 />}
                {props.leval == 2 && <No2 />}
                {props.leval == 3 && <No3 />}
                {props.leval == 4 && <No4 />}
                {props.leval == 5 && <No5 />}
              </div>
            )}

            <Image
              src={props.imgUrl ? props.imgUrl : ""}
              alt={props.productName}
              width={200}
              height={200}
            />
          </a>
        </Link>
        {!!(props.inStock && props.isGroup == 0) && (
          <>
            {props.preSales == 1 ? (
              <div className={styles["act_user_sel"]}>
                <Link href={props.url} legacyBehavior>
                  <a
                    rel="noopener noreferrer"
                    style={{ display: "block", width: "100%", height: "100%" }}
                  ></a>
                </Link>
                <div className={styles["sel_add"]}>
                  <Button
                    className={styles["pre_order_btn"]}
                    onClick={preOrder}
                    loading={btnLoading}
                  >
                    PRE-ORDER
                  </Button>
                </div>
              </div>
            ) : (
              <div
                className={styles["act_user_sel"]}
                style={showAdded ? { display: "block" } : {}}
              >
                <Link href={props.url} legacyBehavior>
                  <a
                    rel="noopener noreferrer"
                    style={{ display: "block", width: "100%", height: "100%" }}
                  ></a>
                </Link>
                <div
                  className={styles["sel_add"]}
                  style={showAdded ? { display: "none" } : {}}
                >
                  <Button
                    className={styles["add_addtocart_btn"]}
                    onClick={(event) => {
                      setBtnLoading(true);
                      addToCart(
                        event,
                        {
                          productID: props.productID,
                          qty: 1,
                          location: props.location,
                          position: props.position,
                        },
                        addToCartCallBack
                      );
                    }}
                    loading={btnLoading}
                  >
                    Add to Cart
                  </Button>
                </div>
                <div
                  className={styles["added"]}
                  style={showAdded ? { display: "block" } : {}}
                >
                  <p className={styles["addtip"]}>
                    <i
                      className={`iconfont csicon-shopping-cart ${styles["icon-shopping-cart"]}`}
                    />
                    <span>Item added to your cart!</span>
                  </p>
                  <Button
                    className={styles["cart_btn"]}
                    onClick={(event) => {
                      event.stopPropagation();
                      window.location.href = "/viewcart";
                    }}
                  >
                    View Cart
                  </Button>
                  <Button
                    className={styles["checkout_btn"]}
                    onClick={(event) => {
                      event.stopPropagation();
                      window.location.href = "/checkout";
                    }}
                  >
                    Checkout
                  </Button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <div className={styles["goods-info"]}>
        {/* 标签展示 */}
        {!props.hiddenTags && (
          <div className={styles["tag-box"]}>
            {!!props.inStock && <MyTags {...{ ...props, isSingle: false }} />}
          </div>
        )}

        <Link href={props.url} legacyBehavior>
          <a className={styles["goodsLink"]} rel="noopener noreferrer">
            <h3
              className={styles["goods-name"]}
              dangerouslySetInnerHTML={{ __html: props.productName }}
            />
            {!!(
              !props.hiddenDiscount &&
              props.promotion &&
              props.promotion?.promotionRate
            ) && (
              <div className={styles["goods-discount"]}>
                <div className={styles["goods-discount-num"]}>
                  {props.promotion.promotionRate}
                </div>
                <div className={styles["goods-discount-unit"]}>
                  <div>%</div>
                  <div>OFF</div>
                </div>
              </div>
            )}
          </a>
        </Link>

        {/* 商品价格 */}
        <div className={styles["goods-price"]}>
          <div className={styles["price"]}>
            <b>
              ${price[0]}
              <i>.{price.length === 2 ? price[1] : "00"}</i>
            </b>
          </div>
          {props.normalPrice && props.normalPrice !== props.price && (
            <div className={styles["crossedPrice"]}>
              <b>$ {props.normalPrice}</b>
            </div>
          )}
        </div>

        {
          props.showAfterpaybenifit ? (
            <div className={styles["afterpay-benefit"]}>
              or 4 payments
              <br />
              <div className={styles['per-price']}>
                of {(props.price / 4).toFixed(2)} with
                <Image
                  alt={"afterpay logo"}
                  width={87}
                  height={24}
                  src={"https://img.crazysales.com.au/newsletter/images/afterpay/afterpay.png"}
                ></Image>
              </div>
            </div>
          ) : null
        }

        {!props.hiddenReviews && props.inStock ? (
          // 有库存
          <>
            {
              <div
                className={`${styles["goods-start"]} ${
                  props.review.total - 0 > 0 ? "" : styles["goods-start-hidden"]
                }`}
              >
                <Rate
                  style={{ fontSize: "16px", color: "#ffc33d" }}
                  allowHalf
                  disabled
                  value={props.review.avgRank}
                />
                <span className={styles["commitNum"]}>
                  ({props.review.total})
                </span>
              </div>
            }
          </>
        ) : (
          // 无库存时候显示，所有商品
          <div
            className={styles["notify-box"]}
            style={props.hiddenReviews ? { display: "none" } : undefined}
          >
            <Button className={styles["btn"]} href={props.url} type="primary">
              NOTIFY ME
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}